<template>
    <v-container
        :id="
            section.columnId && section.columnId[$i18n.locale]
                ? section.columnId[$i18n.locale].current
                : section._key
        "
        :class="{
            'container--columns': true,
            'text-center': section.textAlign && section.textAlign === 'center',
            'text-right': section.textAlign && section.textAlign === 'right',
        }"
        :fluid="section.fullWidth"
    >
        <v-row column justify-center align-center>
            <v-col
                cols="12"
                lg="6"
                :class="{
                    'column-image--left': section.contentRight,
                    'column-image--right': !section.contentRight,
                    'pa-0': true,
                }"
            >
                <EmbedYouTube
                    v-if="section.video && section.video.videoID"
                    :video="section.video.videoID"
                />
                <div
                    v-else-if="
                        section.image &&
                        section.image.imageId &&
                        section.image.imageDir &&
                        section.isBackground
                    "
                    :style="calcSanityUrl"
                    class="mdAndDown-h30vw"
                ></div>
                <EmbedSanityImage
                    v-else-if="
                        section.sanityImageBackground &&
                        section.sanityImageBackground.selectedImage
                    "
                    :selectedImage="
                        section.sanityImageBackground &&
                        section.sanityImageBackground.selectedImage
                    "
                    :alt="
                        section.sanityImageBackground &&
                        section.sanityImageBackground.alt &&
                        section.sanityImageBackground.alt[$i18n.locale]
                            ? section.sanityImageBackground.alt
                            : {
                                  en: 'c3controls image',
                                  es: 'c3controls image',
                              }
                    "
                    fit="scale"
                    image-align="center"
                    height="400"
                    :width="
                        $vuetify.breakpoint.lgAndUp ||
                        $vuetify.breakpoint.xsOnly
                            ? '600'
                            : '720'
                    "
                    :border-radius="false"
                    :innerClasses="
                        $vuetify.breakpoint.xsOnly ? 'no-border-radius' : ''
                    "
                />
                <!-- <div v-if="section.image &&
                            section.image.imageId &&
                            section.image.imageDir"><pre>{{section.image}}</pre></div> -->
            </v-col>
            <v-col
                cols="12"
                lg="6"
                :class="{
                    'column-content--right': section.contentRight,
                    'column-content--left': !section.contentRight,
                    'pa-0': true,
                }"
            >
                <div
                    v-if="section.blurbage && section.blurbage[$i18n.locale]"
                    :class="{
                        'vertical-center-parent': true,
                    }"
                    style="max-width: 80%; margin: auto"
                >
                    <BlockContent
                        :blocks="section.blurbage[$i18n.locale]"
                        :serializers="serializers"
                    />
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { cl } from '~/plugins/global.js'
import serializers from '~/util/sanity/serializers'
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import EmbedYouTube from '~/components/embeds/EmbedYouTube.vue'
export default {
    name: 'ContentColumnImageColumn',
    components: {
        EmbedCloudinary2,
        EmbedYouTube,
        EmbedSanityImage,
    },
    props: {
        section: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            serializers,
        }
    },
    computed: {
        // calcSrc() {
        //     if (
        //         this.section &&
        //         this.section.image &&
        //         this.section.image.imageId &&
        //         this.section.image.imageDir
        //     ) {
        //         return this.calcImageInlineStyle(
        //             cl.url(
        //                 `${this.section.image.imageDir}/${this.section.image.imageId}`,
        //                 {
        //                     width: 1000,
        //                     crop: 'scale',
        //                     fetch_format: 'auto',
        //                     flags: 'lossy',
        //                     quality: 'auto',
        //                 }
        //             ),
        //             this.section.image
        //         )
        //     } else {
        //         return ''
        //     }
        // },
        calcSanityUrl() {
            if (this.section?.sanityImageBackground?.selectedImage) {
                const sanityImgUrl = this.$img(this.$urlFor(
                    this.section.sanityImageBackground.selectedImage
                )
                    .fit('scale')
                    .url(), { format: 'webp' })
                // const sanityImgUrl = this.$urlFor(
                //     this.section.sanityImageBackground.selectedImage
                // )
                //     .fit('scale')
                //     .url()
                
                return this.calcImageInlineStyle(
                    sanityImgUrl,
                    this.section.sanityImageBackground
                )
            } else {
                return ''
            }
        },
    },
    methods: {
        calcImageInlineStyle(imageUrl, settings) {
            let focus = 'center center'
            if (settings.focus === 'topLeft') {
                focus = 'left top'
            } else if (settings.focus === 'topRight') {
                focus = 'right top'
            } else if (settings.focus === 'bottomRight') {
                focus = 'right bottom'
            } else if (settings.focus === 'bottomLeft') {
                focus = 'left bottom'
            }
            return `background-image:url(${imageUrl});background-size:cover;background-repeat:no-repeat;background-position: ${focus};height:100%`
        },
    },
}
</script>
